(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purerdl-cable-request"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(section){
    const picker=section.querySelector('[data-prdl-cable-picker]');
    if(!picker||picker.dataset.prdlReady==='1')return;
    picker.dataset.prdlReady='1';
    const buttons=Array.from(picker.querySelectorAll('[data-prdl-form]'));
    const panels=Array.from(section.querySelectorAll('[data-prdl-form-panel]'));
    function show(index){
      buttons.forEach(function(button){
        const active=Number(button.dataset.prdlForm)===index;
        button.classList.toggle('is-active',active);
        button.setAttribute('aria-selected',active?'true':'false');
      });
      panels.forEach(function(panel){
        const active=Number(panel.dataset.prdlFormPanel)===index;
        panel.classList.toggle('is-hidden',!active);
        panel.hidden=!active;
      });
    }
    buttons.forEach(function(button){
      button.addEventListener('click',function(){
        show(Number(button.dataset.prdlForm));
      });
    });
    show(0);
  }
  function initAll(){
    document.querySelectorAll('.prdl-cable-page').forEach(init);
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initAll,{once:true});
  }else{
    initAll();
  }
  document.addEventListener('shopify:section:load',initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purerdl-recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function(){
  const section=document.querySelector('[data-prdl-recently-viewed]');
  if(!section)return;

  const key='purerdl_recently_viewed_v2_'+(section.dataset.language||'de')+'_'+(section.dataset.currency||'EUR')+'_'+section.dataset.country;
  const current={
    id:String(section.dataset.productId||''),
    url:section.dataset.productUrl||'',
    title:section.dataset.productTitle||'',
    image:section.dataset.productImage||'',
    priceCents:Number(section.dataset.productPriceCents||0),
    taxable:section.dataset.productTaxable!=='false'
  };

  let items=[];
  try{
    const stored=JSON.parse(localStorage.getItem(key)||'[]');
    if(Array.isArray(stored))items=stored;
  }catch(e){items=[];}

  const previous=items.filter(function(item){return String(item.id)!==current.id && item.url;}).slice(0,4);
  const grid=section.querySelector('[data-prdl-recently-viewed-grid]');

  function createCard(item){
    const wrapper=document.createElement('div');
    wrapper.className='prdl-rv-card card-wrapper product-card-wrapper';
    const card=document.createElement('div');
    card.className='card card--card card--media';

    const imageWrap=document.createElement('a');
    imageWrap.className='prdl-rv-card__image';
    imageWrap.href=item.url;
    if(item.image){
      const img=document.createElement('img');
      img.src=item.image;
      img.alt=item.title||'';
      img.loading='lazy';
      imageWrap.appendChild(img);
    }

    const body=document.createElement('div');
    body.className='prdl-rv-card__body';

    const title=document.createElement('a');
    title.className='prdl-rv-card__title';
    title.href=item.url;
    title.textContent=item.title||'';

    const price=document.createElement('div');
    price.className='prdl-rv-card__price';
    if(window.PureRDLPriceDisplay){
      price.appendChild(window.PureRDLPriceDisplay.createMoney(item.priceCents,item.taxable,section.dataset.currency||'EUR'));
      const label=document.createElement('span');
      label.innerHTML=section.dataset.priceLabel||'';
      price.appendChild(label);
    }

    body.appendChild(title);
    body.appendChild(price);
    card.appendChild(imageWrap);
    card.appendChild(body);
    wrapper.appendChild(card);
    return wrapper;
  }

  if(previous.length && grid){
    previous.forEach(function(item){grid.appendChild(createCard(item));});
    section.hidden=false;
  }

  const updated=[current].concat(items.filter(function(item){return String(item.id)!==current.id;})).slice(0,8);
  try{localStorage.setItem(key,JSON.stringify(updated));}catch(e){}
})();

  } catch(e) { console.error(e); }
})();
})();
